import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from "@helium10/re-ui-components";
import styled from "styled-components";
import { Container } from "../../Styles";
export const SkeletonTitle = () => {
    return (_jsx(Header, { children: _jsx(Logo, {}) }));
};
const Header = styled(Container) `
  gap: 26px;
  margin-bottom: 12px;
`;
const Logo = styled(Skeleton) `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  height: 100px;
  width: 100px;
`;
